import DepositCoolingOffSettings from "@/models/Products/ProductSettings/DefaultSettings/CoolingOff/CoolingOffSettings";

export default class AccountDepositCoolingOffSettings extends DepositCoolingOffSettings {
    overridden: boolean = false;
}